import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  ICustomerBankAccount,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class CustomerBankAccount
  extends BaseModel<CustomerBankAccount, 'CustomerBankAccount'>
  implements ICustomerBankAccount
{
  static override readonly modelName: AbilitySubjectType =
    'CustomerBankAccount';

  customerId!: string;
  iban!: string;
  owner!: string;
  options?: Record<string, any> | null;

  @Type(() => Date)
  deletedAt?: Date | null;
}
